import { render, staticRenderFns } from "./BulkEditExtendedDueDateModal.vue?vue&type=template&id=b38a52d2&"
import script from "./BulkEditExtendedDueDateModal.vue?vue&type=script&lang=js&"
export * from "./BulkEditExtendedDueDateModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkEditExtendedDueDateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports